
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"comment.label":"Versionskommentar"},"en":{"comment.label":"Version comment"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();